import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const OverviewAccountSkeleton = () => (
    <div className="col-lg-5 col-md-12 col-sm-12">
        <div className="row accountDetail">
            <div className="accountType mb-3">
                <Skeleton variant="rectangular" width={200} height={25} />
            </div>
            <div className="accountamount mb-1">
                <Skeleton variant="rectangular" width={'100%'} height={200} />
            </div>
            <div className="accountamount">
                <Skeleton variant="rectangular" width={'100%'} height={40} />
            </div>
        </div>
    </div>
);

export default OverviewAccountSkeleton;